import { ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({
  children,
  containerId,
}: {
  children: ReactNode;
  containerId: string;
}) => {
  const [mounted, setMounted] = useState(false);
  const portalRef = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    portalRef.current = document.getElementById(containerId);
    setMounted(true);
  }, [containerId]);

  return mounted && portalRef.current
    ? createPortal(children, portalRef.current)
    : null;
};

export default Portal;
